import { JsonObject, JsonProperty } from "typescript-json-serializer";
import {GeometryConfiguration} from "./geometry-configuration";
import {TimeExtentConfiguration} from "./time-info-configration";

@JsonObject()
export class FeatureFilterConfiguration {
    /**
     * Specifies a search distance from a given [geometry](https://developers.arcgis.com/javascript/latest/api-reference/esri-views-layers-support-FeatureFilter.html#geometry) in a spatial filter.
     *
     * [Read more...](https://developers.arcgis.com/javascript/latest/api-reference/esri-views-layers-support-FeatureFilter.html#distance)
     */
    @JsonProperty()
    declare distance: number;
    /**
     * The geometry to apply to the spatial filter.
     *
     * [Read more...](https://developers.arcgis.com/javascript/latest/api-reference/esri-views-layers-support-FeatureFilter.html#geometry)
     */
    @JsonProperty()
    declare geometry: GeometryConfiguration;
    /**
     * An array of objectIds of the features to be filtered.
     *
     * [Read more...](https://developers.arcgis.com/javascript/latest/api-reference/esri-views-layers-support-FeatureFilter.html#objectIds)
     */
    @JsonProperty()
    declare objectIds: number[];
    /**
     * For spatial filters, this parameter defines the spatial relationship to filter features in the layer view against the filter [geometry](https://developers.arcgis.com/javascript/latest/api-reference/esri-layers-support-FeatureFilter.html#geometry).
     *
     * @default "intersects"
     *
     * [Read more...](https://developers.arcgis.com/javascript/latest/api-reference/esri-layers-support-FeatureFilter.html#spatialRelationship)
     */
    @JsonProperty()
    declare spatialRelationship: string;
    /**
     * A range of time with start and end date.
     *
     * @default null
     *
     * [Read more...](https://developers.arcgis.com/javascript/latest/api-reference/esri-views-layers-support-FeatureFilter.html#timeExtent)
     */
    @JsonProperty()
    declare timeExtent: TimeExtentConfiguration;
    /**
     * The unit for calculating the buffer distance when [distance](https://developers.arcgis.com/javascript/latest/api-reference/esri-views-layers-support-FeatureFilter.html#distance) is specified in a spatial filter.
     *
     * @default null
     *
     * [Read more...](https://developers.arcgis.com/javascript/latest/api-reference/esri-views-layers-support-FeatureFilter.html#units)
     */
    @JsonProperty()
    declare units?: "feet" | "miles" | "nautical-miles" | "us-nautical-miles" | "meters" | "kilometers";
    /**
     * A where clause for the feature filter.
     *
     * [Read more...](https://developers.arcgis.com/javascript/latest/api-reference/esri-views-layers-support-FeatureFilter.html#where)
     */
    @JsonProperty()
    declare where: string;

    constructor() {}
}
